var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('nav-bar',{on:{"loginClick":_vm.loginClick}}),(!_vm.isLogin)?_c('div',{staticClass:"content"},[_c('select-one'),_c('select-two'),_c('select-third'),_c('select-five'),_c('select-six')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }